import { Component, HostListener, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalService } from 'ng-devui';
import { zip } from 'rxjs';
import { FilePreviewType } from 'src/app/modules/shared/components/file-preview-entry/file-preview-entry.component';
import {
  FilePreviewComponent,
  ViewScreenType,
} from 'src/app/modules/shared/components/file-preview/file-preview.component';
import {
  TableColumnConfig,
  TableColumnType,
  TableConfig,
} from 'src/app/modules/shared/components/table-pro/table.config';
import { HostDirective } from 'src/app/modules/shared/directives/host.directive';
import { JgLoadInspReportFileListRequest } from 'src/app/modules/shared/models/jg/jg-load-insp-report-file-list-request.model';
import { JgLoadInspReportFile } from 'src/app/modules/shared/models/jg/jg-load-insp-report-file.model';
import { JgLoadInsp } from 'src/app/modules/shared/models/jg/jg-load-insp.model';
import { JgPhysicalInspUnitDwListRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-dw-list-request.model';
import { JgPhysicalInspUnitDw } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-dw.model';
import { JgPhysicalInspUnitFxItemSearchRequest } from 'src/app/modules/shared/models/jg/jg-physical-insp-unit-fx-item-search-request.model';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { OrganizationType } from 'src/app/modules/shared/models/staff/organization-type.enum';
import { NzTreeNode } from 'src/app/modules/shared/models/tree-node.model';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OrderType } from 'src/app/modules/shared/providers/request/order-type.enum';
import { JgLoadInspReportFileService } from 'src/app/modules/shared/services/jg-load-insp-report-file.service';
import { JgLoadInspService } from 'src/app/modules/shared/services/jg-load-insp.service';
import { JgPhysicalInspUnitDwService } from 'src/app/modules/shared/services/jg-physical-insp-unit-dw.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { DialogJgLoadComponent } from '../../../dialogs/dialog-jg-load/dialog-jg-load.component';

@Component({
  selector: 'app-handover-insp-load',
  templateUrl: './handover-insp-load.component.html',
  styleUrls: ['./handover-insp-load.component.scss'],
})
export class HandoverInspLoadComponent {
  @ViewChild(HostDirective, { static: true }) hiddenHost!: HostDirective;

  config?: TableConfig = new TableConfig();

  mainRequest: JgPhysicalInspUnitFxItemSearchRequest =
    new JgPhysicalInspUnitFxItemSearchRequest();

  searchRequest: JgPhysicalInspUnitFxItemSearchRequest =
    new JgPhysicalInspUnitFxItemSearchRequest();

  pager = this.globalService.recoverPager();

  totalWidth = 0;
  scrollTop = 0;

  recordList: JgLoadInsp[] = [];

  cascaderOptions: NzTreeNode[] = [];

  cascaderValue: number[] = [];

  sectionList: ProjectSection[] = [];

  inspUnitDwList: JgPhysicalInspUnitDw[] = [];

  reportList: JgLoadInspReportFile[] = [];

  get withToken() {
    return '?token=' + this.globalService.token;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private projectSectionService: ProjectSectionService,
    private jgPhysicalInspUnitDwService: JgPhysicalInspUnitDwService,
    private jgLoadInspService: JgLoadInspService,
    private jgLoadInspReportFileService: JgLoadInspReportFileService,
    private projectSectionItemService: ProjectSectionItemService,
    private globalService: GlobalService,
    private modalService: ModalService,
  ) {}

  get canWrite(): boolean {
    if (location.href.indexOf('#/open') > -1) {
      const query = window.location.href.split('?')[1] ?? '';
      const params = new URLSearchParams(query);
      return params.get('writeable') === 'true';
    }
    return this.globalService.writeAbleByUrl('/handover/load');
  }

  ngOnInit(): void {
    this.getSectionList();
  }

  getSectionList() {
    this.projectSectionService
      .findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      })
      .subscribe((projectSections) => {
        this.sectionList = projectSections;
        this.buildSectionTree(projectSections);
      });
  }

  private buildSectionTree(res: ProjectSection[]) {
    const jgSectionIds: number[] = [];
    for (const section of this.globalService.userInfo.projectSections ?? []) {
      if (section.sectionType === OrganizationType.JG_CHECK) {
        jgSectionIds.push(section.sectionId!);
      }
    }
    if (jgSectionIds.length === 0) {
      this.sectionList = [];
      return;
    }
    const cSectionIds: number[] = [];
    if (
      this.globalService.userInfo.organizationType ===
      OrganizationType.CONSTRUCTION
    ) {
      for (const section of this.globalService.userInfo.projectSections ?? []) {
        if (section.sectionType === OrganizationType.CONSTRUCTION) {
          cSectionIds.push(section.sectionId!);
        }
      }
    }
    const jgSections = res.filter((s) => jgSectionIds.includes(s.id!));
    const treeNode: NzTreeNode[] = [];
    for (const section of jgSections) {
      const jgNode = {
        label: section.name!,
        value: section.id!,
        children: [] as NzTreeNode[],
      };
      for (const cSection of section.projectSectionSections ?? []) {
        if (cSection.refSectionType === OrganizationType.CONSTRUCTION) {
          if (
            this.globalService.userInfo.organizationType ===
            OrganizationType.CONSTRUCTION
          ) {
            if (!cSectionIds.includes(cSection.refSectionId!)) {
              continue;
            }
          }
          jgNode.children!.push({
            label: cSection.refSectionName,
            value: cSection.refSectionId!,
            isLeaf: true,
          });
        }
      }
      if (jgNode.children!.length > 0) {
        treeNode.push(jgNode);
      }
    }
    this.cascaderOptions = treeNode;
    if (
      this.cascaderOptions.length > 0 &&
      this.cascaderOptions[0].children!.length > 0
    ) {
      this.cascaderValue = [
        this.cascaderOptions[0].value,
        this.cascaderOptions[0].children![0].value,
      ];
    }
    this.onSectionChange();
  }

  onSectionChange() {
    setTimeout(() => {
      this.mainRequest.dwCode = '';
      if (this.cascaderValue.length > 0) {
        this.getInspUnitDwList();
      }
    }, 50);
  }

  private getInspUnitDwList() {
    this.jgPhysicalInspUnitDwService
      .findAll<JgPhysicalInspUnitDwListRequest>({
        projectId: this.globalService.projectId,
        jgSectionId: this.cascaderValue[0],
        sectionId: this.cascaderValue[1],
      })
      .subscribe((dwList) => {
        this.inspUnitDwList = dwList.filter(
          (dw) => dw.dwCode?.includes('Q') || dw.dwCode?.includes('X'),
        );
        this.mainRequest.jgSectionId = this.cascaderValue[0];
        this.mainRequest.sectionId = this.cascaderValue[1];
        this.mainRequest.projectId = this.globalService.projectId;
        this.initConfig();
      });
  }

  getReportList() {
    this.jgLoadInspReportFileService
      .findAll<JgLoadInspReportFileListRequest>({
        projectId: this.globalService.projectId,
        jgSectionId: this.mainRequest.jgSectionId,
        sectionId: this.mainRequest.sectionId,
      })
      .subscribe((res) => {
        this.reportList = res;
      });
  }

  addReport() {
    const reportInit = new JgLoadInsp();
    reportInit.projectId = this.globalService.projectId;
    reportInit.jgSectionId = this.mainRequest.jgSectionId;
    reportInit.sectionId = this.mainRequest.sectionId;
    const results = this.modalService.open({
      backdropCloseable: false,
      component: DialogJgLoadComponent,
      onClose: () => {},
      data: {
        data: reportInit,
        onCancel: () => {
          results.modalInstance.hide();
        },
        onConfirm: () => {
          this.getReportList();
          this.searchRecord();
          results.modalInstance.hide();
        },
      },
    });
  }
  @HostListener('window:visibilitychange')
  handleVisibilityChange() {
    this.searchRecord();
  }

  searchRecord() {
    this.jgLoadInspService
      .search<JgPhysicalInspUnitFxItemSearchRequest>(
        this.searchRequest,
        this.pager.pageIndex - 1,
        this.pager.pageSize,
      )
      .subscribe((data) => {
        this.globalService.savePager(this.pager);
        for (const record of data.content) {
          record.codeName = `${record.code ?? ''} ${record.name ?? ''}`;
          if (record.spotChecked === true) {
            record.qualifiedText =
              record.qualified === true ? '合格' : '不合格';
          } else {
            record.qualifiedText = '';
          }
        }
        if (this.searchRequest.dwCodeSortOrder !== OrderType.ASC) {
          this.recordList = data.content.sort((a, b) => {
            if (a.code && b.code) {
              return b.code.localeCompare(a.code);
            }
            return 0;
          });
        } else {
          this.recordList = data.content;
        }
        this.pager.total = data.totalElements;
      });
  }

  resetSearch() {
    this.searchRequest = JSON.parse(JSON.stringify(this.mainRequest));
    this.searchRequest.dwCodeSortOrder = OrderType.ASC;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  private prepareSearch(data: any) {
    const searchRequest = new JgPhysicalInspUnitFxItemSearchRequest();
    searchRequest.projectId = this.globalService.projectId;
    searchRequest.jgSectionId = this.mainRequest.jgSectionId;
    searchRequest.sectionId = this.mainRequest.sectionId;
    searchRequest.dwCode = this.mainRequest.dwCode;
    Object.assign(searchRequest, data);
    this.searchRequest = searchRequest;
  }

  searchClick(data: any) {
    this.prepareSearch(data);
    this.searchRecord();
  }

  initConfig() {
    const dwOptions = this.inspUnitDwList
      .map((dw) => ({
        label: `${dw.dwCode} ${dw.dwName}`,
        value: dw.dwCode!,
      }))
      .sort((a, b) => {
        return a.value.localeCompare(b.value);
      });

    const columns: TableColumnConfig[] = [
      {
        name: '桥梁单位工程',
        key: 'codeName',
        type: TableColumnType.text,
        width: 240,
        queryable: true,
        queryKey: 'code',
        options: dwOptions,
        sortable: true,
        sortKey: 'dwCodeSortOrder',
        sortDefault: OrderType.ASC,
        sortOrder: 1,
        patternStr: 'E+240',
      },
      {
        name: '里程桩号',
        key: 'dwMileage',
        type: TableColumnType.text,
        width: 240,
        queryable: true,
        queryKey: 'dwMileage',
        patternStr: 'E+240',
        align: 'left',
        editable: () => this.canWrite,
      },
      {
        name: '抽检与否',
        key: 'spotChecked',
        type: TableColumnType.options,
        options: [
          {
            label: '抽检',
            value: true,
          },
          {
            label: '不抽检',
            value: false,
          },
        ],
        width: 70,
        queryable: true,
        queryKey: 'spotChecked',
        editable: () => this.canWrite,
      },
      {
        name: '试验结果',
        key: 'qualified',
        type: TableColumnType.options,
        options: [
          {
            label: '合格',
            value: true,
          },
          {
            label: '不合格',
            value: false,
          },
        ],
        width: 70,
        queryable: true,
        queryKey: 'qualified',
        editable: () => this.canWrite,
      },
      {
        name: '报告',
        key: 'hasReport',
        type: TableColumnType.imgAction,
        width: 70,
        cover: (row: number) => {
          return !!this.recordList[row].hasReport
            ? './assets/imgs/img-pdf.png'
            : '';
        },
        view: (row: number) => {
          const record = this.recordList[row];
          this.jgLoadInspReportFileService
            .listBySectionItemId(record.sectionItemId!)
            .subscribe((res) => {
              if (res.length > 0) {
                this.view(res[0].id!);
              }
            });
        },
      },
      {
        name: '备注',
        key: 'comment',
        type: TableColumnType.text,
        width: 400,
        align: 'left',
        patternStr: 'E+400',
        editable: () => this.canWrite,
      },
    ];

    this.config = {
      hasIndex: true,
      columns,
      headerSize: 12,
      bodySize: 13,
    };

    this.totalWidth = columns.reduce((acc, cur) => acc + cur.width, 56);

    this.resetSearch();

    this.getReportList();
  }

  calcResultChange(result: string) {}

  queryPanelStateChange(isOpen: boolean) {
    console.log(isOpen);
    if (isOpen === false) {
      this.resetSearch();
    }
  }

  onScroll(e: Event) {
    this.scrollTop = (e.target as HTMLElement).scrollTop;
  }

  onScrollEnd(e: Event) {
    this.scrollTop = (e.target as HTMLElement).scrollTop;
  }

  private openInTab(url: string) {
    const target = window.open(url, '_blank');
    setTimeout(() => {
      target?.postMessage({
        type: 'redir',
        data: window.location.href,
      });
    }, 1000);
    // target?.postMessage('redir', window.location.href);
  }

  pageIndexChange(index: number) {
    this.pager.pageIndex = index;
    this.searchRecord();
  }

  pageSizeChange(size: number) {
    this.pager.pageSize = size;
    this.pager.pageIndex = 1;
    this.searchRecord();
  }

  view(id: number) {
    // const id = this.reportList[index].id;
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/entity/view-report-load/${id}?token=${params.get('token')}&writeable=${params.get('writeable')}`,
      );
    } else {
      this.openInTab(`#/entity/view-report-load/${id}`);
    }
    // const results = this.modalService.open({
    //   backdropCloseable: false,
    //   component: FilePreviewComponent,
    //   onClose: () => {},
    //   data: {
    //     fileList: this.reportList.map((r) => r.fileId!),
    //     previewType: FilePreviewType.PDF,
    //     screenType: ViewScreenType.FullScreen,
    //     index: index,
    //     cantReplace: true,
    //     onDismiss: () => {
    //       results.modalInstance.hide();
    //     },
    //     onFileChange: (fileList: string[]) => {
    //       const removeReportsReq = this.reportList
    //         .filter((r) => !fileList.includes(r.fileId!))
    //         .map((r) => this.jgLoadInspReportFileService.remove(r.id!));
    //       zip(removeReportsReq).subscribe(() => {
    //         this.getReportList();
    //         this.resetSearch();
    //       });
    //     },
    //   },
    // });
  }

  sign(workFlowKey: string) {
    const query = window.location.href.split('?')[1] ?? '';
    const params = new URLSearchParams(query);
    if (location.href.indexOf('#/open/') > -1) {
      this.openInTab(
        `#/open/custom-form/sign/${workFlowKey!}?token=${params.get('token')}`,
      );
    } else {
      this.openInTab(`#/custom-form/sign/${workFlowKey!}`);
    }
  }

  afterEdit(data: { row: number; key: string }) {
    const { row, key } = data;
    if (key === 'dwMileage') {
      this.updateMileage(row);
    } else {
      if (this.recordList[row].id) {
        this.editRecord(row);
      } else {
        this.createRecord(row);
      }
    }
  }

  private createRecord(row: number) {
    const record = JSON.parse(
      JSON.stringify(this.recordList[row]),
    ) as JgLoadInsp;
    record.projectId = this.globalService.projectId;
    record.jgSectionId = this.mainRequest.jgSectionId;
    record.sectionId = this.mainRequest.sectionId;
    this.jgLoadInspService.create(record).subscribe((res) => {
      this.searchRecord();
    });
  }

  private updateMileage(row: number) {
    const item = this.recordList[row];
    this.projectSectionItemService
      .updateDwMileage({
        dwSectionItemId: item.sectionItemId!,
        dwMileage: item.dwMileage ?? '',
      })
      .subscribe(() => {
        this.searchRecord();
      });
  }

  private editRecord(row: number) {
    this.jgLoadInspService.update(this.recordList[row]).subscribe((res) => {
      this.searchRecord();
    });
  }
}
